import Cookies from 'js-cookie';

const getToken = async () => {
  let authToken = Cookies.get('token');
  let userRole = Cookies.get('userRole');
  if (!authToken) {
    // Logic to fetch and set token if not available
    // This could involve making a request to get a new token
    authToken = Cookies.get('token'); // Implement this function based on your auth flow
    Cookies.set('token', authToken);
  }
  // return `${authToken}?role=${userRole}`;
  return authToken;
};

export const getHeaders = async () => {
  const token = await getToken();
  const userRole = Cookies.get('userRole');
  return {
    headers: {
      authorization: `${token}`
      // role: userRole
    }
  };
};

export const getFileHeaders = async () => {
  const token = await getToken();
  return {
    headers: {
      authorization: `${token}`,
      Accept: 'application/pdf',
      'Content-Type': 'application/pdf'
    }
  };
};

export const getExcelHeaders = async () => {
  const token = await getToken();
  return {
    headers: {
      authorization: `${token}`,
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  };
};
